import React from "react";
import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { motion } from "framer-motion";
import { Trophy } from "lucide-react";
import api from "@/lib/api";
import BadgeTag from "@/components/BadgeTag";

export default function ChampionSpotlight() {
  const { data: winners = [] } = useQuery({
    queryKey: ["winners"], queryFn: async () => (await api.get("/battles/winners")).data,
    staleTime: 60_000,
  });
  const w = winners[0];
  if (!w) return null;
  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 py-8">
      <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
        className="comic-card p-5 sm:p-6 border-gold flex flex-col sm:flex-row items-center gap-5" data-testid="champion-spotlight">
        <img src={`${process.env.REACT_APP_BACKEND_URL}${w.winner.image_url}`} alt="champion meme"
          className="w-40 h-40 object-contain border-3 border-black bg-white shrink-0" />
        <div className="flex-1 text-center sm:text-left">
          <span className="flex items-center justify-center sm:justify-start gap-1.5 text-gold font-display font-900 uppercase text-xs">
            <Trophy className="w-4 h-4" /> Reigning Champion · Battle #{String(w.number || 1).padStart(3, "0")}
          </span>
          <h3 className="font-display font-900 text-cream text-2xl mt-2 uppercase">{w.title}</h3>
          <div className="flex items-center justify-center sm:justify-start gap-2 mt-2">
            {w.winner.user_id
              ? <Link to={`/u/${w.winner.user_id}`} className="font-mono text-sm text-neon hover:underline">@{w.winner.username}</Link>
              : <span className="font-mono text-sm text-dim">@{w.winner.username}</span>}
            <BadgeTag rob={w.winner.rob} />
            <span className="font-mono text-xs text-dim">▲ {w.winner.votes}</span>
          </div>
          <Link to="/hall-of-fame" className="btn-ghost mt-4 !py-2 !px-4 !text-xs inline-flex !border-gold hover:!bg-gold">See The Hall Of Fame</Link>
        </div>
      </motion.div>
    </section>
  );
}
